import React, { useEffect, useState } from "react";
import {
  IClinicImage,
  IClinicInfo,
  ITreatment,
  IDoctor,
} from "./types/clinic.types";
import {
  MOCK_IMAGES,
  MOCK_INFO,
  MOCK_ABOUT,
  MOCK_TREATMENTS,
  MOCK_DOCTORS,
} from "./mockData";

// Import Components
import { ClinicImages } from "./components/ClinicImages";
import { ClinicInfo } from "./components/ClinicInfo";
import { AboutUs } from "./components/AboutUs";
import { Treatments } from "./components/Treatments";
import { Doctors } from "./components/Doctors";
import "./styles/main.scss";
import bookUrl from "../../../api/bookUrl";
import { setClinicData } from "../../../redux/bookclinic/bookclinicaction";
export const ClinicManagementPage: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [images, setImages] = useState<IClinicImage[]>(MOCK_IMAGES);
  const [info, setInfo] = useState<IClinicInfo>(MOCK_INFO);
  const [about, setAbout] = useState<string>(MOCK_ABOUT);
  const [treatments, setTreatments] = useState<ITreatment[]>(MOCK_TREATMENTS);
  const [doctors, setDoctors] = useState<IDoctor[]>(MOCK_DOCTORS);

  useEffect(() => {
    bookUrl
      .get("/bookingclinic/clinic/findBookClinicId")
      .then((response) => {
        const clinicData = response?.data?.data;

        if (clinicData) {
          // Set all your states from the API response
          setImages(clinicData.images || []);
          setInfo(clinicData);
          setAbout(clinicData.about);
          setTreatments(clinicData.bookTreatment || []);
          console.log(clinicData.bookTreatment);

          setClinicData(clinicData);
        }
      })
      .catch(console.error)
      .finally(() => {
        setIsLoading(false);
      });
  }, []);
  useEffect(() => {
    bookUrl
      .get("/bookingclinic/clinic/findEmployee", {
        headers: { status: true },
      })
      .then((response) => {
        const clinicData = response?.data?.data;

        setDoctors(clinicData);
      })
      .catch(console.error)
      .finally(() => {
        setIsLoading(false);
      });
  }, []);
  // --- Handlers to update state (passed to children) ---
  const handleImagesChange = (newImages: IClinicImage[]) => {
    setImages(newImages);
  };

  const handleInfoChange = (newInfo: IClinicInfo) => {
    setInfo(newInfo);
  };

  const handleAboutChange = (newAbout: string) => {
    setAbout(newAbout);
  };

  const handleTreatmentsChange = (newTreatments: ITreatment[]) => {
    setTreatments(newTreatments);
  };

  const handleDoctorsChange = (newDoctors: IDoctor[]) => {
    setDoctors(newDoctors);
  };
  if (isLoading) {
    return (
      <div className="clinic-management-page-loading">
        <h2>Loading Clinic Data...</h2>
        {/* You could put a CSS spinner here */}
      </div>
    );
  }
  return (
    <div className="clinic-management-page">
      {/* 1. Top Area: Clinic Images */}
      <div className="grid-images">
        <ClinicImages images={images} onImagesChange={handleImagesChange} />
      </div>
      {/* 2. Left Column: Basic Info */}
      <div className="grid-info">
        <ClinicInfo info={info} onInfoChange={handleInfoChange} />
      </div>
      {/* 3. Right/Main Column */}
      <div className="grid-main">
        {/* 3.1 About Us */}
        <AboutUs aboutContent={about} onAboutChange={handleAboutChange} />
        {/* 3.2 Treatments */}
        <Treatments
          treatments={treatments}
          onTreatmentsChange={handleTreatmentsChange}
        />
        {/* 3.3 Doctors */}
        <Doctors
          doctors={doctors}
          treatments={treatments} // Pass treatments for the multi-select
          onDoctorsChange={handleDoctorsChange}
        />
      </div>
    </div>
  );
};
